import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';




class CreditcardOptions extends Component {
  render() {
    return (
      <div className='RewardsOptions'>
        <img className='logo' src={logo}></img>
        <br />
        <div>
          How Much Do You Want to Fill to Your Wallet...
        </div>
        <br />
        <div><Link to='/creditcard100'>Buy 100 coins</Link></div>
        <br />
        <div><Link to='/creditcard300'>Buy 300 coins</Link></div>
        <br />
        <div><Link to='/creditcard500'>Buy 500 coins</Link></div>
        <br />
        <div><Link to='/creditcard1000'>Buy 1000 coins</Link></div>
        <br />
        <div><Link to='/creditcard2000'>Buy 2000 coins</Link></div>
        <br />
        <div><Link to='/creditcard5000'>Buy 5000 coins</Link></div>
        <br />
        <div><Link to='/creditcard10000'>Buy 10000 coins</Link></div>
        <br />
        <div>
          For more than 10000 coins please contact the admin at admin1@newwaveconsultantsbkk.com
        </div>
        <br />
        <div>Powered by</div>
        <img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
        </div>
    );
  }
}
export default CreditcardOptions;
